
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Row, Spinner } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { useSelector } from "react-redux";
import axios from 'axios';
import { Table } from "react-bootstrap";
import { OrderAPI } from '../../helpers/firebase_helper';

const Pricing = () => {
    const [currentPlan, setCurrentPlan] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const profileData = useSelector((state) => state.Profile.profileData);
    const navigate = useNavigate();
    const [nextChargeDate, setNextChargeDate] = useState(null);
    useEffect(() => {
        const fetchPlans = async () => {
            setLoading(true);
            try {

                const response = await OrderAPI.getPlans();
                const plans = response.result;


                const currentPlanDetails = profileData?.result?.current_plan;
                const currentFrequency = profileData?.result?.billing_frequency;
                const nextChargeDateFromProfile = profileData?.result?.next_charge_date;

                setNextChargeDate(nextChargeDateFromProfile);

                if (currentPlanDetails && plans) {

                    const matchedPlan = plans.find(
                        (plan) =>
                            plan.plan_name === currentPlanDetails &&
                            plan.period === currentFrequency
                    );

                    if (matchedPlan) {
                        setCurrentPlan({
                            ...matchedPlan,
                            period: currentFrequency || "monthly",
                        });
                    }
                }
            } catch (error) {
                console.error("Error fetching plans:", error);
                setError("Failed to fetch plans. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchPlans();
    }, [profileData]);


    const handleManageSubscription = () => {
        navigate('/billing/plans');
    };

    document.title = "Media Engine | Current Plan";

    return (

        <React.Fragment>
            <div className="page-content ">
                <Container fluid>
                    <BreadCrumb title="Current Plan" pageTitle="Billing" />
                    {loading ? (
                        <div className="text-center">
                            <Spinner color="primary" />
                            <p>Loading your current plan...</p>
                        </div>
                    ) : error ? (
                        <div className="text-center text-danger">
                            <p>{error}</p>
                        </div>
                    ) : currentPlan ? (
                        <Row className="justify-content-center fs-7 lh-lg">
                            <Col >
                                <Card className="shadow-sm">
                                    <CardBody>

                                        <Row className="align-items-center mb-3">
                                            <Col>
                                                <h5 className="text mb-0">
                                                    {/* {currentPlan.plan_name} ({currentPlan.period}) */}
                                                    {currentPlan.plan_name} {currentPlan.plan_name !== 'Basic' && `(${currentPlan.period})`}
                                                </h5>
                                                {currentPlan.plan_name !== 'Basic' && (
                                                    <small className="text">
                                                        You are on a <b>{currentPlan.period}</b> plan and next charge will be on <b>{nextChargeDate}</b>.
                                                    </small>
                                                )}
                                            </Col>
                                            <Col className="text-end">
                                                <Button
                                                    color="primary"
                                                    onClick={handleManageSubscription}
                                                >
                                                    Manage Subscription
                                                </Button>
                                            </Col>
                                        </Row>
                                        <hr />
                                        <div className="border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
                                            <h6 className="mb-3"><strong>Plan Details</strong></h6>

                                            <Table bordered hover responsive size="sm" className="mb-3" style={{ width: "100%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ whiteSpace: "nowrap", padding: "4px 10px", width: "40%" }}>
                                                            <b>Users</b>
                                                        </td>
                                                        <td style={{ whiteSpace: "nowrap", padding: "4px 10px" }}>
                                                            {currentPlan.features?.Users || "1 Basic User"}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Max Video Length</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Max_Video_Length}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Max Video Size</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Max_Video_Size}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Bandwidth</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Bandwidth}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Storage</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Storage_DTO}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Email Support</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Email_Support}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Thumbnail Generation</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Thumbnail_Generation ? "Yes" : "No"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Analytics</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Analytics}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Chat Support</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Chat_Support}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: "4px 10px" }}><b>Geo Restrictions</b></td>
                                                        <td style={{ padding: "4px 10px" }}>{currentPlan.features?.Geo_Restrictions ? "Yes" : "No"}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>

                                            <hr />

                                            <div className="d-flex justify-content-between fw-bold">
                                                <span>Monthly Total:</span>
                                                <span>${currentPlan.plan_amount}/month</span>
                                            </div>
                                        </div>


                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        <div className="text-center">
                            <p>No current plan found.</p>
                        </div>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Pricing;
